export default __webpack_public_path__ + "static/egress-3-8da78d8583f4045c9bddbab7e87dd03c.png";